import { styled } from '@mui/material';
import clsx from 'clsx';

import { IReadOnlyNumberInputProps, VARIANT } from './types';
import { NumberInputControlled } from '../NumberInputControlled';

import styles from './ReadOnlyNumberInput.module.scss';

import scssVariables from 'styles/sass-variables.module.scss';

const StyledInput = styled((props: IReadOnlyNumberInputProps) => <NumberInputControlled {...props} />)(({ look }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    color: look === VARIANT.SUCCESS ? scssVariables.green_default : scssVariables.black,
  },
  fieldset: {
    border: `1px solid ${look === VARIANT.SUCCESS ? scssVariables.green_default : scssVariables.greys_border}`,
  },
}));

export const ReadOnlyNumberInput: React.FC<IReadOnlyNumberInputProps> = ({
  disabled,
  className,
  decimalScale = 2,
  ...restProps
}) => (
  <StyledInput
    {...restProps}
    disabled={disabled}
    className={clsx(styles.summaryTextfield, { [styles.disabled]: disabled }, className)}
    decimalScale={decimalScale}
  />
);
